import { FC } from 'react';
import { WbDrawer } from '@agilelab/plugin-wb-platform';
import { useAssignmentsContext } from '../AssignmentsContext';
import { AssignmentForm } from './AssignmentForm';
import { ManageAssignmentsDrawerContextProvider } from './ManageAssignmentsDrawerContext';

export const AssignmentsDrawer: FC = () => {
  const { openManageDrawer, setOpenManageDrawer, roleId } =
    useAssignmentsContext();

  return (
    <ManageAssignmentsDrawerContextProvider>
      <WbDrawer
        open={openManageDrawer}
        setOpen={setOpenManageDrawer}
        title={`Assign ${roleId} role`}
      >
        <AssignmentForm />
      </WbDrawer>
    </ManageAssignmentsDrawerContextProvider>
  );
};
